import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export const PublicLayout = () => (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
        <Header />
        <main className="flex-1">
            <Outlet />
        </main>
        <Footer />
    </div>
);

export default PublicLayout;
